/**
 * 租户成品数据配置
 * 日期：2019-7-16
 * 作者：xie.zhengyun
 */
"use strict";
angular.module("tenantDataConfigModule", ["tenantDataConfigServiceModule", "configDetailModule"])
    .controller("tenantDataConfigCtrl", ["$scope", "trsHttpService", "$state", "tenantDataConfigService", "$q", "modalDialog", function($scope, trsHttpService, $state, tenantDataConfigService, $q, modalDialog) {
        initStatus()
        initData()
        /**
         * [initStatus description] 状态初始化
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.status = {
                // 全部---数字报—网站—客户端—微信—微博—电视台—广播
                statusList: [
                    { name: '全部渠道', value: '' }, { name: '数字报', value: 'szb' }, { name: '网站', value: 'wz' },
                    { name: '客户端', value: 'app' }, { name: '微信', value: 'wx' }, { name: '微博', value: 'wb' },
                ],
                selectedStatus: [],
                items: [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
                keywords: '',
                hotLists: {
                    page: {
                        'CURRPAGE': 1,
                        'PAGESIZE': 20,
                        'PAGECOUNT': 0,
                        'ITEMCOUNT': 0
                    },
                    status: {
                        'jumpToPageNum': 1,
                        'startpage': 0
                    }
                },
                tenantId: $state.params.tenantid,
            }
            $scope.data = {
                productList: []
            }
        }
        /**
         * [initData description] 状态初始化
         * @return {[type]} [description]
         */
        function initData() {
            $scope.status.selectedStatus = $scope.status.statusList[0];
            getProductList();
        }
        /**
         * [getProductList description] 获取产品列表
         * @return {[type]} [description]
         */
        function getProductList() {
            let defer = $q.defer();
            let params = {
                serviceid: "mlf_tenantdatadivide",
                methodname: "queryProductsByTenantId",
                TenantId: $scope.status.tenantId,
                ChannelType: $scope.status.selectedStatus.value,
                Keyword: $scope.status.keywords,
                PageNum: $scope.status.hotLists.page.CURRPAGE,
                PageSize: $scope.status.hotLists.page.PAGESIZE,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post").then(function(data) {
                $scope.data.productList = data.CONTENT.DATA;
                $scope.status.hotLists.page.ITEMCOUNT = data.CONTENT.TOTALNUM;
                $scope.status.hotLists.page.CURRPAGE = data.CONTENT.PAGENUM;
                $scope.status.hotLists.page.PAGESIZE = data.CONTENT.PAGESIZE;
                $scope.status.hotLists.page.PAGECOUNT = data.CONTENT.PAGECOUNT;
                defer.resolve();
            });
            return defer.promise;
        }
        /**
         * [requestData description] 数据请求
         * @param  {[type]} ev [description]
         * @return {[type]}    [description]
         */
        $scope.requestData = function(ev) {
            if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                getProductList();
            }
        }
        /**
         * [edit description] 编辑
         * @return {[type]} [description]
         */
        $scope.edit = function(item) {
            tenantDataConfigService.editShareData($scope.status.tenantId, item).then(() => {
                modalDialog.alertType('', '规则保存成功', 'success', false);
                getProductList();
            });
        }
        /**
         * [channelFormat description] 所属栏目转化
         * @param  {[type]} type [description] 栏目type
         * @return {[type]}      [description]
         */
        $scope.channelFormat = function(type) {
            let typeStr = '';
            switch (type) {
                case 'app':
                    typeStr = '客户端';
                    break;
                case 'szb':
                    typeStr = '数字报';
                    break;
                case 'wz':
                    typeStr = '网站';
                    break;
                case 'wb':
                    typeStr = '微博';
                    break;
                case 'wx':
                    typeStr = '微信';
                    break;
            }
            return typeStr;
        }
        /**
         * [pageChanged description]分页请求
         * @return {[type]} [description]
         */
        $scope.pageChanged = function() {
            $scope.status.hotLists.status.jumpToPageNum = $scope.status.hotLists.page.CURRPAGE;
            getProductList();
        };
        /**
         * [jumpToPage description] 根据页码跳转
         * @return {[type]} [description]
         */
        $scope.jumpToPage = function() {
            if ($scope.status.hotLists.status.jumpToPageNum > $scope.status.hotLists.page.PAGECOUNT) {
                $scope.status.hotLists.status.jumpToPageNum = $scope.status.hotLists.page.PAGECOUNT;
            }
            if ($scope.status.hotLists.status.jumpToPageNum === "0" || isNaN(Number($scope.status.hotLists.status.jumpToPageNum))) {
                modalDialog.alertType("请输入合法的页码", "", "warning", false);
                return;
            }
            getProductList();
        };
    }]);